<template>
<div v-loading="loading" >
  <w-transaction-info-view class="mr-b15" :tx-info="txInfo" />
  <el-table-wrapper style="width: 100%;" show-overflow-tooltip :data="callTreeList" :columns="columns" :column-default="columnDefault" border :pagination="false" :show-custom-header="true" :show-search-tool="false">
    <template slot-scope="scope" slot="step-slot">
      <span v-if="scope.row.stacks" class="activestack">ActiveStack</span>
      <span v-else class="link c-pointer" @click="showDetailContents(scope.row)">{{ formatterStepName(scope.row) }}</span>
    </template>
  </el-table-wrapper>
  <w-call-list-detail-popup ref="detailPopup" />
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { sortBy, isEmpty as objectIsEmpty } from 'lodash';
import { defaultProps } from '@/constants/tree';
import { columnDefault } from '@/constants/table';
import { isEmpty } from '@/utils/basic';
import { getValueAfterCheckEmpty } from '@/utils/string';
import { convertMillisecondsToSeconds } from '@/utils/number';
import TransactionAPI from '@/api/apm/transaction';
import WTransactionInfoView from '../TransactionInfoView';
import WCallListDetailPopup from '../popup/CallListDetailPopup';
import { TX_ID_STRING, OBJ_HASH } from '@/constants/apm-domain-define';

export default {
  name: 'WCallListTable',
  components: { WTransactionInfoView, WCallListDetailPopup },
  props: {
    activeTab: String,
    params: Object,
  },
  data() {
    return {
      columnDefault,
      columns: [
        { prop: 'index', label: '번호', width: 80, headerAlign: 'center', sortable: true, formatter: this.converIndex },
        { prop: 'parent', label: '상위 번호', width: 80, headerAlign: 'center', sortable: true, formatter: this.converIndex },
        { prop: 'timeText', label: '시간', width: 130, headerAlign: 'center' },
        {
          label: '수행 시간',
          headerAlign: 'center',
          childColumns: [
            { prop: 'timeGap', label: '경과', width: 80, headerAlign: 'center', sortable: true, formatter: this.convertMillisecondsValue },
            { prop: 'timeStack', label: '누적', width: 85, headerAlign: 'center', sortable: true, formatter: this.convertMillisecondsValue },
          ],
        },
        {
          label: 'CPU 시간',
          headerAlign: 'center',
          childColumns: [
            { prop: 'cpuGap', label: '경과', width: 85, headerAlign: 'center', sortable: true, formatter: this.convertMillisecondsValue },
            { prop: 'cpuStack', label: '누적', width: 85, headerAlign: 'center', sortable: true, formatter: this.convertMillisecondsValue },
          ],
        },
        { prop: 'stepTypeName', label: '구분', width: 100, headerAlign: 'center', sortable: true, formatter: this.convertEmptyText },
        { prop: 'executeTime', label: '처리 시간', width: 85, headerAlign: 'center', sortable: true, formatter: this.convertMillisecondsValue },
        { prop: 'contents', label: '내용', showOverflowTooltip: true, headerAlign: 'center', sortable: true, scopedSlot: 'step-slot' },
      ],
      defaultProps,
      callTreeList: [],
      loading: false,
      txid: null,
      txInfo: {},
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    activeTab() {
      this.loadData();
    },
    params() {
      this.loadData();
    },
  },
  methods: {
    /**
     * call tree 데이터 조회
     * @return {[type]} [description]
     * @author jda
     */
    loadData() {
      if (this.activeTab !== 'callList' || objectIsEmpty(this.params) || this.txid === this.params.txid) {
        return;
      }
      this.txid = this.params.txid;
      this.loading = true;
      // 리스트
      const requestParam = {};
      requestParam[TX_ID_STRING] = this.params.txid;
      requestParam[OBJ_HASH] = this.selectedNode.objHash;
      TransactionAPI.getDetailCallTree(requestParam).then((response) => {
        this.loading = false;
        if (response.data.success) {
          const result = response.data.data;
          this.callTreeList = sortBy(result.profile, 'index');
          this.txInfo = result.tx;
        } else {
          this.txInfo = {};
          this.callTreeList = [];
        }
      });
    },
    /**
     * 스텝 + 단계 파싱
     * @param  {[type]} record [description]
     * @return {[type]}        [description]
     * @author jda
     */
    formatterStepName(record) {
      let contents = record.contents;
      if (isEmpty(contents)) {
        contents = getValueAfterCheckEmpty(contents);
      }
      return contents;
    },
    reset() {
      this.txInfo = {};
      this.callTreeList = [];
    },
    /**
     * milliseconds -> seconds 단위 변환
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     * @author jda
     */
    convertMillisecondsValue(row, column, value) {
      return convertMillisecondsToSeconds(value);
    },
    /**
     * start, end 트랜잭션일 경우 번호는 '*'로 표현
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     * @author jda
     */
    converIndex(row, column, value) {
      if (value === -1 || value === 999999) {
        return '*';
      }
      return value;
    },
    /**
     * 데이터 없을 경우 EMPTY_TEXT
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     * @author jda
     */
    convertEmptyText(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * 내용 상세보기 팝업
     * @param  {[type]} record [description]
     * @return {[type]}        [description]
     * @author jda
     */
    showDetailContents(record) {
      const contents = this.formatterStepName(record);
      this.$refs.detailPopup.open(contents);
    },
  },
};
</script>

<style scoped>
.activestack {
  background: #868e96;
  color: white;
  font-weight: bold;
  border-radius: 100px;
  padding: 5px 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/apm/transaction-matrix/components/table/CallListTable.vue